(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    window.PXUTheme.theme_settings.cart_action_type === 'ajax' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    window.PXUTheme.cartDrawer.loadDrawer(true);
  });

  document.addEventListener('product-form:message:success', (event) => {
    event.preventDefault();
  });

  document.addEventListener('product-form:cart:update', (event) => {
    const { item_count } = event.detail.cart;
    window.PXUTheme.cartDrawer.updateCartCount(item_count);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-icons"] && !Shopify.designMode) return;
  try {
    
class TextWithIconsBlocks extends HTMLElement {
  connectedCallback() {
    if (this.dataset.mobileLayout !== 'carousel') return;

    // Defer until after the browser has performed layout
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.initSlideshow();
      });
    });
  }

  initSlideshow() {
    const blockCount = parseInt(this.dataset.blockCount, 10);
    const hasMultiple = blockCount > 1;

    this.slideshow = new Flickity(this, {
      watchCSS: true,
      wrapAround: true,
      // cellAlign: 'left',
      draggable: true,
      prevNextButtons: false,
      pageDots: hasMultiple,
      autoPlay: true,
      imagesLoaded: true,
      accessibility: false,
    });
  }

  disconnectedCallback() {
    if (this.slideshow) {
      this.slideshow.destroy();
      this.slideshow = null;
    }
  }
}

customElements.define('text-with-icons-blocks', TextWithIconsBlocks);

  } catch(e) { console.error(e); }
})();
})();
